"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }


var _peers = require('shared/selectors/peers');

// "Patients can use the app" (org_settings.PatientAppEnabled on the server).

const orgFor = (state, orgKey) =>
  _nullishCoalesce(_optionalChain([state, 'access', _ => _.orgs, 'optionalAccess', _2 => _2[orgKey]]), () => ( _optionalChain([state, 'access', _3 => _3.dataV2, 'optionalAccess', _4 => _4.orgs, 'optionalAccess', _5 => _5[orgKey]])))

// The org's setting. It's off until an admin turns it on, so an org with no
// value, or one that isn't loaded (a loading, expired or invalid secure
// link), reads as off, as on the server.
 const selectIsPatientAppEnabled = (state, orgKey) =>
  !!orgKey && _optionalChain([orgFor, 'call', _6 => _6(state, orgKey), 'optionalAccess', _7 => _7.PatientAppEnabled]) === true; exports.selectIsPatientAppEnabled = selectIsPatientAppEnabled

// The org is loaded and has the app off. The patient app's in-chat notice
// uses it, so the notice never shows while the org is still loading (D-13).
 const selectIsPatientAppKnownOff = (state, orgKey) => {
  const org = orgKey ? orgFor(state, orgKey) : undefined
  return !!org && org.PatientAppEnabled !== true
}; exports.selectIsPatientAppKnownOff = selectIsPatientAppKnownOff

// "App user" on the staff profile: the server says the patient uses the app
// for this record (Patient.AppUser), and the org keeps the app on. Reading
// the org here hides the badge as soon as an admin turns the app off.
 const selectIsPatientAppUser = (state, patientKey) => {
  const patient = _peers.selectPatientByKey.call(void 0, state, patientKey)
  return !!patient && 'AppUser' in patient && patient.AppUser === true
    && exports.selectIsPatientAppEnabled.call(void 0, state, patient.OrgKey)
}; exports.selectIsPatientAppUser = selectIsPatientAppUser
